import notification from "antd/es/notification";
import { getIsDarkMode } from "utils/misc";

export const openNotification = (
  description: string,
  title?: string,
  type: string = "success",
  duration?: number,
  placement = "bottomLeft"
) => {
  const isDarkMode = getIsDarkMode();
  const typeToDefaultTitle: Record<string, string> = {
    success: "Success",
    error: "Error",
    warning: "Warning",
  };

  (notification as any)[type]({
    message: title || typeToDefaultTitle[type],
    description: description,
    duration,
    placement,
    className: isDarkMode ? "dark-mode" : "",
  });
};
